export const JourneysListSkeleton = () => (
  <div className="animate-pulse flex flex-col gap-3">
    <div className="rounded-xl p-3 bg-white shadow-sm">
      <span className="block bg-gray-200 rounded h-4 w-1/2 mb-2" />
      <span className="block bg-gray-200 rounded h-2 w-1/3 mb-3" />
      <span className="block bg-gray-200 rounded h-2 w-full" />
    </div>

    <div className="flex gap-2">
      {[1, 2, 3].map(i => (
        <span key={i} className="block bg-gray-200 rounded-full" style={{ width: 80, height: 30 }} />
      ))}
    </div>

    {[1, 2, 3].map(i => (
      <div key={i} className="flex gap-3 items-center p-3 bg-white rounded-xl shadow-sm">
        <span className="shrink-0 bg-gray-200 rounded-lg" style={{ width: 56, height: 56 }} />
        <div className="grow">
          <span className="block bg-gray-200 rounded h-4 w-7/12 mb-2" />
          <span className="block bg-gray-200 rounded h-2 w-4/12 mb-2" />
          <span className="block bg-gray-200 rounded h-2 w-full" />
        </div>
      </div>
    ))}
  </div>
)
